<template>
  <div class="card">
    <div class="card-body hm400">
      <h5 class="card-title text-center font-weight-bold">Client Watch List</h5>
      <div  class="table-container">
        <div class="" v-if="loading">
          <!-- Show the loader when async operation is going on -->
          <div class="loader"></div>
        </div>
        <perfect-scrollbar class="scroll-area-modal" v-else >
          <table  class="table table-striped single-outage-table">
            <thead>
            <tr>
              <th width="35%" class='text-left' scope="col">Customer Name</th>
              <th scope="col" width="60%" >Email</th>
              <th class='text-left' scope="col">Remove</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="value in clientWatchList" :key="value.uid">
              <td class="d-flex justify-content-between  align-items-center">
                <div >
                  <img width="50%" :src="`https://www.gravatar.com/avatar/${emailHashGravatar(value.email)}?s=50`">
                </div>
                <div class="mr-auto">{{ value.firstName}} {{value.lastName}}</div>
              </td>
              <td class="text-left">
                {{ value.email }}
              </td>
              <td class="text-center">
                <button type="button" rel="tooltip" class="btn btn-outline-danger btn-icon btn-sm" @click="removeClientFromWatchList(value.uid)">
                  <i class="fa fa-times"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </perfect-scrollbar >
        <div v-if="clientWatchList && clientWatchList.length === 0 && !loading">  <p class="hm300 card-text text-center text-danger mb-3 font-weight-bold">No data found.</p></div>
      </div>
      </div>

  </div>
</template>
<script>
import {db, messaging} from "@/firebase/init";
import md5 from "crypto-js/md5";
import swal from "sweetalert2";
import {PerfectScrollbar} from "vue2-perfect-scrollbar";

export default {
  name: "RecentTicket",
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  components: {
    PerfectScrollbar
  },
  data () {
    return {
      clientWatchList: [],
      userWatchList: [],
      loading: false,
    }
  },
  mounted() {
    this.getAllWatchClients();
  },
  methods: {
    emailHashGravatar(email) {
      console.log('email', email)
      if (email === null) {
        return null
      } else {
        return md5(email.trim().toLowerCase()).toString()
      }
    },
    async getAllWatchClients(){
      try{
        this.loading = true;
        const ref = await db.collection('users').doc(this.user.uid).get();
        if(!ref.exists){
          throw new Error('User not found')
        }
        const user = ref.data();
        const {watchList , userWatchList}= user;
        this.userWatchList=userWatchList;
        this.clientWatchList=watchList;
      }
      catch(e){
       console.log(e.toString(), 'Could not fetch watch clients')
      }
      finally {
        this.loading=false
      }
    },
    async removeClientFromWatchList(uid){
      try{
        const result=await swal({
          title: "Watch Client Removal!",
          text: `Do you want to remove this?`,
          type: "info",
          confirmButtonText: "Remove",
          confirmButtonColor: "#6ACF98",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          cancelButtonColor: "#EE8057"
        });
        if(result.value){
          this.clientWatchList=this.clientWatchList.filter(value=> value.uid !== uid);
          await db.collection('users').doc(this.user.uid).update({
            watchList: this.clientWatchList,
          });
        }
      }
      catch(e){
        console.log(e)
      }

    }
  },

}
</script>
<style scoped>
.table-container {
  max-height: 280px;
  position: relative;
}

.table {
  width: 100%;
  border-collapse: collapse;
}
.scroll-area {
  position: relative;
  max-height: 350px;
  /*overflow: hidden;*/
}
.scroll-area-modal {
  position: relative;
  max-height: 350px;
  overflow: hidden;
}
</style>
